import { defineStore } from 'pinia'
import Actions from './actions'
import Getters from './getters'
import { useState } from './state'

export { type CruiseListState } from './state'

export const useCruiseListStore = defineStore('cruiseList', {
  state: useState,
  getters: { ...Getters },
  actions: { ...Actions },
})

export type CruiseListStoreContext = ReturnType<typeof useCruiseListStore>